import { GeneralPath, INode } from '@ardoq/yfiles';

/**
 * return the outline of the node within its bounds.
 * this is the point at which the edge will touch the node.
 * the PortAdjustmentPolicy of the graph layout dictates this behavior.
 */
const getNodeOutline = (node: INode) => {
  const { layout, labels } = node;
  const result = new GeneralPath(2);
  result.appendRectangle(layout, false);
  const label = labels.at(0);
  if (!label) {
    return result;
  }
  const {
    layout: { bounds: labelBounds },
  } = label;
  result.appendRectangle(labelBounds, false);
  return result;
};
export { getNodeOutline };
